import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import {
  locationReceiptSettingsGetCustomerReceiptSettings,
  locationsGetById,
  locationTipsSettingsGet,
} from "~/api-refs";
import { LoadingPanel } from "~/components/shared/loading-panel";
import { toConvexTableId } from "~/lib/convex-table-id";

import { CustomerReceiptSettingsForm } from "../../../../../components/receipts/customer-receipt-form";

export const Route = createFileRoute(
  "/_authenticated/locations/$id/receipts/customer-receipt"
)({
  component: CustomerReceiptSettingsPage,
});

function CustomerReceiptSettingsPage() {
  const { id } = Route.useParams();

  const { data: settings, isPending: settingsLoading } = useQuery(
    convexQuery(locationReceiptSettingsGetCustomerReceiptSettings, {
      locationId: toConvexTableId("locations", id),
    })
  );
  const { data: location, isPending: locationLoading } = useQuery(
    convexQuery(locationsGetById, {
      id: toConvexTableId("locations", id),
    })
  );
  const { data: tipsSettings, isPending: tipsSettingsLoading } = useQuery(
    convexQuery(locationTipsSettingsGet, {
      locationId: toConvexTableId("locations", id),
    })
  );

  if (settingsLoading || locationLoading || tipsSettingsLoading) {
    return <LoadingPanel message="Loading settings..." />;
  }

  if (!location) {
    throw new Error("Location not found");
  }

  return (
    <CustomerReceiptSettingsForm
      location={location}
      settings={
        settings
          ? {
              ...settings,
              printerId: settings.printerId ?? null,
              customText: settings.customText ?? null,
              emailSenderName: settings.emailSenderName ?? null,
            }
          : null
      }
      tipsSettings={
        tipsSettings ?? {
          tipMethod: "disabled" as const,
          suggestedAmounts: undefined,
        }
      }
    />
  );
}
